import { render, staticRenderFns } from "./UpdatePackagePopup.vue?vue&type=template&id=2e480ea1&scoped=true"
import script from "./UpdatePackagePopup.vue?vue&type=script&lang=js"
export * from "./UpdatePackagePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e480ea1",
  null
  
)

export default component.exports